import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PollIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M18 1a5 5 0 015 5v8a5 5 0 01-5 5H7.657a3 3 0 00-2.121.879l-2.829 2.828C2.077 23.337 1 22.891 1 22V6a5 5 0 015-5h12zm0 2H6a3 3 0 00-3 3v13.586l1.121-1.122A5 5 0 017.657 17H18a3 3 0 003-3V6a3 3 0 00-3-3zM6 5a1 1 0 01.993.883L7 6v8a1 1 0 01-1.993.117L5 14V6a1 1 0 011-1zm4 5a1 1 0 01.993.883L11 11v3a1 1 0 01-1.993.117L9 14v-3a1 1 0 011-1zm4-4a1 1 0 01.993.883L15 7v7a1 1 0 01-1.993.117L13 14V7a1 1 0 011-1zm4 2a1 1 0 011 1v5a1 1 0 01-2 0V9a1 1 0 011-1z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
PollIcon.isCarinaIcon = true;
export default PollIcon;
